/**
 * Analytics tab of the site detail page. Renders the existing Analytics
 * component (the one figmafolio's FolioForm uses) inside a glass card,
 * passing the project and user identifiers the way FolioForm does
 * (projectId = the url doc id, userId = the owner uid). Its internals are
 * not restyled here; the card wrapper only contains it within the shell.
 *
 * Tier gating mirrors figmafolio: analytics at Solo and above. The Aero
 * locked treatment (AeroFeatureGate) replaces the component's internal
 * figmafolio-styled gate, so below Solo we pass subscriptionType 'solo' to
 * keep that inner gate (sample data, blur, its own CTA) from rendering a
 * second locked state inside ours; the dimmed pointer-events-none preview
 * then shows the dashboard itself.
 */
import React from 'react';
import Analytics from '../../../components/Analytics/Analytics';
import AeroFeatureGate from '../../../components/Aero/AeroFeatureGate';

function SiteAnalyticsTab({ user, site, subscriptionType, openUpgradeModal }) {
  const hasAnalyticsAccess = subscriptionType === 'solo' || subscriptionType === 'pro';

  return (
    <AeroFeatureGate
      requiredTier="solo"
      currentTier={subscriptionType}
      icon="chart"
      title="Site analytics"
      message="See visits to your site and where they come from."
      onUpgradeClick={openUpgradeModal}
      upsellPosition="top"
    >
      <div className="aero-card aero-card-pad aero-sites-analytics-card">
        <Analytics
          projectId={site.id}
          userId={user?.uid}
          generatedUrl={site.generatedUrl}
          customDomain={site.customDomain}
          subscriptionType={hasAnalyticsAccess ? subscriptionType : 'solo'}
        />
      </div>
    </AeroFeatureGate>
  );
}

export default SiteAnalyticsTab;
